<div aria-label="Pagination" class="usa-pagination" role="navigation">
  <ul class="usa-pagination__list">
    <!-- Previous page button -->
    @if (page() > 1) {
      <li class="usa-pagination__item usa-pagination__arrow">
        <a
          href="javascript:void(0);"
          class="usa-pagination__link usa-pagination__previous-page"
          aria-label="Previous page"
          (click)="onPageChange(page() - 1)"
          [class.disabled]="page() === 1"
          ><svg class="usa-icon" aria-hidden="true" role="img">
            <use xlink:href="/assets/img/sprite.svg#navigate_before"></use>
          </svg>
          <span class="usa-pagination__link-text">Previous</span></a
        >
      </li>
    }
    <!-- First page button -->
    @if (totalPages() > 5 && startPage > 1) {
      <li class="usa-pagination__item usa-pagination__page-no">
        <a
          href="javascript:void(0);"
          class="usa-pagination__button"
          [attr.aria-label]="'Page 1'"
          (click)="onPageChange(1)"
          [class.usa-current]="page() === 1"
          >1</a
        >
      </li>
    }
    <!-- Overflow indicator for previous pages -->
    @if (startPage > 2) {
      <li
        class="usa-pagination__item usa-pagination__overflow"
        aria-label="ellipsis indicating non-visible pages"
      >
        <span>…</span>
      </li>
    }
    <!-- Page buttons -->
    @for (pageNum of [].constructor(totalPages()); track pageNum; let i = $index) {
      @if (i + 1 >= startPage && i + 1 <= endPage) {
        <li class="usa-pagination__item usa-pagination__page-no">
          <a
            href="javascript:void(0);"
            class="usa-pagination__button"
            [attr.aria-label]="'Page' + (i + 1)"
            (click)="onPageChange(i + 1)"
            [class.usa-current]="page() === i + 1"
            >{{ i + 1 }}</a
          >
        </li>
      }
    }
    <!-- Overflow indicator for next pages -->
    @if (endPage < totalPages() - 1) {
      <li
        class="usa-pagination__item usa-pagination__overflow"
        aria-label="ellipsis indicating non-visible pages"
      >
        <span>…</span>
      </li>
    }
    <!-- Last page button -->
    @if (totalPages() > 5 && endPage < totalPages()) {
      <li class="usa-pagination__item usa-pagination__page-no">
        <a
          href="javascript:void(0);"
          class="usa-pagination__button"
          [attr.aria-label]="'Page' + totalPages()"
          (click)="onPageChange(totalPages())"
          [class.usa-current]="page() === totalPages()"
          >{{ totalPages() }}</a
        >
      </li>
    }
    <!-- Next page button -->
    @if (page() < totalPages()) {
      <li class="usa-pagination__item usa-pagination__arrow">
        <a
          href="javascript:void(0);"
          class="usa-pagination__link usa-pagination__next-page"
          aria-label="Next page"
          (click)="onPageChange(page() + 1)"
          ><span class="usa-pagination__link-text">Next </span
          ><svg class="usa-icon" aria-hidden="true" role="img">
            <use xlink:href="/assets/img/sprite.svg#navigate_next"></use></svg
        ></a>
      </li>
    }
  </ul>
</div>
